import {
  ArrowRightIcon,
  CheckCircleIcon,
} from "@heroicons/react/24/outline";
import { Link } from "react-router-dom";

export default function GradingPalHomeBanner() {
  return (
    <section
      aria-labelledby="gradingpal-home-title"
      className="relative mt-8 overflow-hidden rounded-2xl border border-emerald-200 bg-emerald-50/70 p-6 sm:p-8"
    >
      <div className="grid items-center gap-6 lg:grid-cols-[1.35fr_1fr]">
        <div>
          <p className="text-xs font-semibold uppercase tracking-widest text-emerald-800">
            From the team behind Alayna
          </p>
          <h2
            id="gradingpal-home-title"
            className="mt-3 max-w-sm text-2xl font-semibold leading-tight tracking-tight text-gray-950"
          >
            Start grading your next assignment.
          </h2>
          <p className="mt-3 max-w-sm text-sm leading-relaxed text-gray-700">
            Bring student work and your rubric to GradingPal. Review the scores
            and feedback before sharing.
          </p>
          <Link
            to="/grading"
            className="mt-5 inline-flex min-h-[44px] items-center gap-2 rounded-xl bg-emerald-700 px-5 py-3 text-sm font-semibold text-white hover:bg-emerald-800 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-emerald-700"
          >
            Grade an assignment{" "}
            <ArrowRightIcon aria-hidden="true" className="h-4 w-4" />
          </Link>
        </div>
        <div
          aria-hidden="true"
          className="hidden rounded-xl border border-emerald-200 bg-white p-5 lg:block"
        >
          <p className="flex items-center gap-2 text-lg font-semibold text-gray-950">
            <CheckCircleIcon className="h-7 w-7 text-emerald-700" />
            GradingPal
          </p>
          <div className="mt-4 rounded-lg border border-dashed border-emerald-200 px-3 py-6 text-center">
            <p className="text-sm font-medium text-gray-900">
              Start with work you have
            </p>
            <p className="mt-2 text-xs text-gray-500">
              Assignment · Rubric · Student responses
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
